import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';
import { Parallax } from 'react-scroll-parallax';

import Image from '../../../Core/Image';
import RichText, { fragment } from '../../../Core/RichText';
import Container from '../../../Core/Container';
import IndividualBlade from '../../IndividualBlades';
import { isNotEmpty } from '../../../../utils';

import {
  Title,
  SubHead,
  CardWrapper,
  Wrapper,
  Content,
  CtaContainer,
  StyledLink,
} from './styles';

const richTextContentAsTitle = (_, children) =>
  isNotEmpty(children) ? <Title>{children}</Title> : null;

const title = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: richTextContentAsTitle,
    [BLOCKS.HEADING_1]: richTextContentAsTitle,
    [BLOCKS.HEADING_2]: richTextContentAsTitle,
    [BLOCKS.HEADING_3]: richTextContentAsTitle,
    [BLOCKS.HEADING_4]: richTextContentAsTitle,
    [BLOCKS.HEADING_5]: richTextContentAsTitle,
    [BLOCKS.HEADING_6]: richTextContentAsTitle,
  },
};

const subHead = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <SubHead>{children}</SubHead>,
  },
};

const AnimatedCreditCardsHero = ({ data, className = '' }) => {
  if (!data) return null;

  const {
    component,
    heading,
    subheading,
    ctas,
    mediaimageDam,
    backgroundAssetDam,
    backgroundColor,
  } = data;

  return (
    <Container className={className || component} type="animated-credit-cards">
      <Wrapper
        image={
          backgroundAssetDam && backgroundAssetDam[0].asset.localImage.publicURL
        }
        backgroundColor={backgroundColor}
      >
        <Content backgroundColor={backgroundColor}>
          {heading && <RichText document={heading} options={title} />}
          {subheading && <RichText document={subheading} options={subHead} />}
        </Content>
        <CardWrapper>
          <div className="img1">
            <Parallax y={[-60, 45]}>
              <Image
                src={mediaimageDam[0]}
                alt={mediaimageDam[0].altText || ''}
              />
            </Parallax>
          </div>

          <div className="img2">
            <Parallax y={[-30, 30]}>
              <Image
                src={mediaimageDam[1]}
                alt={mediaimageDam[1].altText || ''}
              />
            </Parallax>
          </div>
          <div className="img3">
            <Image
              src={mediaimageDam[2]}
              alt={mediaimageDam[2].altText || ''}
            />
          </div>
        </CardWrapper>
      </Wrapper>
      {ctas && (
        <CtaContainer>
          {ctas.map(cta => {
            return cta.internal.type === 'ContentfulBlade' ? (
              <IndividualBlade key={cta.id} data={cta} />
            ) : (
              <StyledLink key={cta.id} data={cta}>
                <RichText document={cta.label} options={fragment} />
              </StyledLink>
            );
          })}
        </CtaContainer>
      )}
    </Container>
  );
};

AnimatedCreditCardsHero.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

export default AnimatedCreditCardsHero;
